export default function safeFloating(amount, positiveOnly) {
  if (typeof amount === "number") {
    return positiveOnly ? Math.max(0, parseFloat(amount.toFixed(10))) : parseFloat(amount.toFixed(10));
  } else {
    return amount;
  }
}
